import { connect } from "react-redux";
import Budget from "./Budget";
import {
  budgets,
  budgetLoading,
  budgetsLoading,
  budgetPagination,
  getError,
} from "../../store/selectors/budgets.selector";
import {
  getBudgetsRequest,
  createBudgetRequest,
  updateBudgetRequest,
  deleteBudgetRequest,
} from "../../store/actions/budgets.actions";

const mapDispatchToProps = {
  getBudgetsRequest,
  createBudgetRequest,
  updateBudgetRequest,
  deleteBudgetRequest,
};

const mapStateToProps = (state) => {
  const allBudgets = budgets(state);
  const pageLoading = budgetsLoading(state);
  const loading = budgetLoading(state);
  const pagination = budgetPagination(state);
  const error = getError(state);
  return { error, allBudgets, pagination, loading, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Budget);
